import type * as z from 'zod';

import { revenueLockdownFormSchemaRaw } from './revenue-lockdown-form-schema';

export const revenueLockdownCreateSchema = revenueLockdownFormSchemaRaw.omit({
  id: true,
});
export type RevenueLockdownCreateSchema = z.infer<typeof revenueLockdownCreateSchema>;

export const revenueLockdownUpdateSchema = revenueLockdownCreateSchema;
export type RevenueLockdownUpdateSchema = z.infer<typeof revenueLockdownUpdateSchema>;
